import React from 'react';

import { Button } from 'components';

import styles from './GetStartedFooter.module.scss';
import { useTranslation } from 'hooks';

interface GetStartedFooterProps {
  skip: any;
  addToGroup: any;
  addToGroupDisabled: boolean;
}

export const GetStartedFooter: React.FC<GetStartedFooterProps> = ({
  skip,
  addToGroup,
  addToGroupDisabled,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <Button size="Small" type="Cancel" onClick={skip}>
        {t('group-get-started.footer.skip')}
      </Button>
      <Button size="Small" disabled={addToGroupDisabled} onClick={addToGroup}>
        {t('group-get-started.footer.add')}
      </Button>
    </div>
  );
};
